<template>
  <div>
    <div :class="`custom-card custom-card-${this.type}`">
      <div class="left-icon-btn" @click="displaySubTab = !displaySubTab">
        <i class="fa" :class="displaySubTab ? 'fa-minus' : 'fa-plus'"></i>
      </div>

      <div class="card-data">
        <div class="card-column">
          <span>{{ coachs.length }}</span>
          <span>Coachs</span>
        </div>

        <div class="card-column">
          <span>{{ longevityRate }}</span>
          <span
            >Moyenne longevité client
            <el-popover
              placement="top"
              width="500"
              trigger="hover"
              content="Moyenne de toutes les séances validées par tous les coachs avec tous leurs clients (hors séances découvertes, hors commandes marché, hors B2B)."
            >
              <span slot="reference">
                <i class="fa fa-info-circle ml-05"></i>
              </span>
            </el-popover>
          </span>
        </div>
      </div>
    </div>

    <div v-if="displaySubTab" :class="`subtab subtab-${this.type}`">
      <el-table :data="coachsSorted" max-height="400">
        <el-table-column label="Nom" prop="name" sortable>
          <template slot-scope="scope">
            <span class="user-link" @click="(e) => goToCoach(e, scope.row.id)">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="Classement" prop="rank" sortable>
          <template slot-scope="scope">
            {{ scope.row.rank }}
          </template>
        </el-table-column>

        <el-table-column label="Département" prop="department" sortable>
          <template slot-scope="scope">
            {{ scope.row.department.substring(0, 2) }}
          </template>
        </el-table-column>

        <el-table-column prop="clientLongevity" sortable>
          <template v-slot:header>
            <label>Longevité client</label>
            <el-popover
              placement="top"
              width="500"
              trigger="hover"
              content="Moyenne de toutes les séances validées par le coach avec tous ses clients (hors séances découvertes, hors commandes marché, hors B2B)."
            >
              <span slot="reference">
                <i class="fa fa-info-circle ml-05"></i>
              </span>
            </el-popover>
          </template>

          <template slot-scope="scope">
            {{ scope.row.clientLongevity }}
          </template>
        </el-table-column>

        <el-table-column label="Total client(s)" prop="nbClients" sortable>
          <template slot-scope="scope">
            {{ scope.row.nbClients }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coachsProps: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      displaySubTab: false,
      coachs: this.coachsProps.coaches,
      longevityRate: this.coachsProps.longevityRate || 0,
    };
  },

  computed: {
    coachsSorted() {
      const coachWithRank = this.coachs;

      coachWithRank.forEach((coach, index) => {
        coach.rank = index + 1;
      });

      return coachWithRank;
    },
  },

  methods: {
    goToCoach(e, id) {
      e.preventDefault();

      const route = this.$router.resolve({
        name: "user-details",
        params: { id },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
